"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _map = require("@nicbase/map");

var _centerOfMass = _interopRequireDefault(require("@turf/center-of-mass"));

var _helpers = require("@turf/helpers");

var _assetMarker = require("./asset-marker");

var _poiMarker = require("./poi-marker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mapType = 'osm';

var TourDataViewMap = function TourDataViewMap(_ref) {
  var _assetPoint$geometry;

  var waypoints = _ref.waypoints,
      tourAsset = _ref.tourAsset;
  var poiMarkers = (0, _react.useMemo)(function () {
    return waypoints.filter(function (geo) {
      return geo.geometry;
    }).map(function (waypoint) {
      var _waypoint$address, _waypoint$address2, _waypoint$address3, _waypoint$address4, _waypoint$address5;

      var point = (0, _centerOfMass["default"])({
        type: 'Feature',
        geometry: waypoint.geometry
      });
      return (0, _helpers.point)(point.geometry.coordinates, {
        type: 'Feature',
        geometry: waypoint.geometry,
        id: waypoint.poiId,
        status: ['DRIVING'],
        city: (_waypoint$address = waypoint.address) === null || _waypoint$address === void 0 ? void 0 : _waypoint$address.city,
        country: (_waypoint$address2 = waypoint.address) === null || _waypoint$address2 === void 0 ? void 0 : _waypoint$address2.country,
        postalCode: (_waypoint$address3 = waypoint.address) === null || _waypoint$address3 === void 0 ? void 0 : _waypoint$address3.postalCode,
        street: (_waypoint$address4 = waypoint.address) === null || _waypoint$address4 === void 0 ? void 0 : _waypoint$address4.street,
        number: (_waypoint$address5 = waypoint.address) === null || _waypoint$address5 === void 0 ? void 0 : _waypoint$address5.number,
        name: waypoint.poiName,
        waypointType: waypoint.type,
        radius: waypoint.radius
      });
    });
  }, [waypoints]);
  var assetMarker = (0, _react.useMemo)(function () {
    if (tourAsset.position) {
      var _tourAsset$position$g, _tourAsset$position$g2;

      return /*#__PURE__*/_react["default"].createElement(_assetMarker.AssetMarker, {
        properties: tourAsset,
        lat: (_tourAsset$position$g = tourAsset.position.geometry) === null || _tourAsset$position$g === void 0 ? void 0 : _tourAsset$position$g.coordinates[1],
        lng: (_tourAsset$position$g2 = tourAsset.position.geometry) === null || _tourAsset$position$g2 === void 0 ? void 0 : _tourAsset$position$g2.coordinates[0]
      });
    }

    return null;
  }, [tourAsset]);
  var assetPoint = (0, _react.useMemo)(function () {
    var _tourAsset$position;

    if ((_tourAsset$position = tourAsset.position) !== null && _tourAsset$position !== void 0 && _tourAsset$position.geometry) {
      var _tourAsset$position$g3;

      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: (_tourAsset$position$g3 = tourAsset.position.geometry.coordinates) !== null && _tourAsset$position$g3 !== void 0 ? _tourAsset$position$g3 : []
        }
      };
    }

    return null;
  }, [tourAsset]);
  var poiGeofenceFeatures = (0, _react.useMemo)(function () {
    return waypoints.filter(function (geo) {
      return geo.geometry;
    }).map(function (waypoint) {
      return {
        type: 'Feature',
        geometry: waypoint.geometry
      };
    });
  }, [waypoints]);

  var _useUserMap = (0, _map.useUserMap)({
    mapType: mapType
  }),
      _useUserMap$viewport = _useUserMap.viewport,
      zoom = _useUserMap$viewport.zoom,
      latitude = _useUserMap$viewport.latitude,
      longitude = _useUserMap$viewport.longitude,
      height = _useUserMap$viewport.height,
      width = _useUserMap$viewport.width,
      setViewport = _useUserMap.setViewport,
      fitBounds = _useUserMap.fitBounds;

  var _useDimensions = (0, _hooks.useDimensions)(),
      _useDimensions2 = _slicedToArray(_useDimensions, 2),
      container = _useDimensions2[0],
      _useDimensions2$ = _useDimensions2[1],
      viewPortWidth = _useDimensions2$.width,
      viewPortHeight = _useDimensions2$.height; // calculate fit bounds for all poi markers, poi geofences and the asset marker (if available)


  (0, _react.useEffect)(function () {
    var features = [];

    if (assetPoint !== null) {
      features = [].concat(_toConsumableArray(features), [assetPoint]);
    }

    if (poiMarkers.length > 0) {
      features = [].concat(_toConsumableArray(features), _toConsumableArray(poiMarkers), _toConsumableArray(poiGeofenceFeatures));
    }

    if (features.length > 0) {
      fitBounds({
        type: 'FeatureCollection',
        features: features
      }, {
        padding: 30
      });
    }
  }, [assetPoint, fitBounds, poiGeofenceFeatures, poiMarkers]);
  (0, _react.useEffect)(function () {
    setViewport(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        height: viewPortHeight !== null && viewPortHeight !== void 0 ? viewPortHeight : 0,
        width: viewPortWidth !== null && viewPortWidth !== void 0 ? viewPortWidth : 0
      });
    });
  }, [viewPortHeight, viewPortWidth, setViewport]);
  var onPoiMarkerClick = (0, _react.useCallback)(function (_ref2) {
    var lat = _ref2.lat,
        lng = _ref2.lng;
    return setViewport(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        latitude: lat,
        longitude: lng,
        zoom: 13
      });
    });
  }, [setViewport]);
  var renderPoiMarkers = (0, _react.useMemo)(function () {
    return poiMarkers.map(function (poiMarker) {
      return /*#__PURE__*/_react["default"].createElement(_poiMarker.PoiMarker, {
        onMarkerClick: onPoiMarkerClick,
        feature: poiMarker,
        lat: poiMarker.geometry.coordinates[1],
        lng: poiMarker.geometry.coordinates[0]
      });
    });
  }, [poiMarkers, onPoiMarkerClick]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-auto h-128 mr-6 my-6 lg:m-0 lg:w-2/3 lg:mx-20",
    ref: container
  }, /*#__PURE__*/_react["default"].createElement(_map.BaseMap, {
    mapType: mapType,
    zoom: zoom,
    latitude: latitude,
    longitude: longitude,
    height: height,
    width: width,
    onViewportChange: setViewport
  }, renderPoiMarkers, (assetPoint === null || assetPoint === void 0 ? void 0 : (_assetPoint$geometry = assetPoint.geometry) === null || _assetPoint$geometry === void 0 ? void 0 : _assetPoint$geometry.coordinates.length) === 2 && assetMarker));
};

TourDataViewMap.propTypes = {
  tourAsset: _propTypes["default"].shape({
    position: _propTypes["default"].shape({
      geometry: _propTypes["default"].shape({
        coordinates: _propTypes["default"].arrayOf(_propTypes["default"].number),
        type: _propTypes["default"].string
      })
    })
  }),
  waypoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    poiId: _propTypes["default"].number,
    poiName: _propTypes["default"].string,
    radius: _propTypes["default"].number,
    poiLongitude: _propTypes["default"].number,
    poiLatitude: _propTypes["default"].number,
    geometry: _propTypes["default"].shape({
      type: _propTypes["default"].string,
      coordinates: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].number))
    })
  }))
};
TourDataViewMap.defaultProps = {
  tourAsset: {},
  waypoints: []
};
var _default = TourDataViewMap;
exports["default"] = _default;